import React from 'react';
import { usePromotionsContext } from '../../hooks/usePromotionsContext';
import PromoCodeWidgetMobile from '../promoCodeWidgetMobile';
import DiscountWidgetMobile from '../discountWidgetMobile';
import { useSelector } from 'react-redux';
import { RootState } from '../../state/store';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { getSubdomainPath } from '../../helpers/pathUtils';

const PromoCodesContainerMobile = () => {
  const { availablePromoCodes } = usePromotionsContext();
  const { id: userId } = useSelector((state: RootState) => state.user);
  const { has_promotions: hasValidPromotions } = useSelector(
    (state: RootState) => state.company,
  );
  const history = useHistory();

  const proceedToLogin = () => {
    localStorage.setItem('postRegistrationPage', '/m/order-details');
    const loginPath = getSubdomainPath('/m/login');
    history.push(loginPath);
  };

  // No valid promotions OR no promo codes → DiscountWidgetMobile (matches desktop fallback)
  if (!hasValidPromotions) {
    return (
      <div
        className='user-promo-codes-container-mobile'
        id='discount-widget-mobile'
      >
        <DiscountWidgetMobile />
      </div>
    );
  }

  // Has promo codes but user not logged in → Log-in prompt
  if (!userId) {
    return (
      <div className='no-user-promo-codes-container-mobile'>
        <div>
          <FormattedMessage
            id='promotion.select_promo_code'
            defaultMessage='Select Promo Code'
          />
        </div>
        <div onClick={proceedToLogin} className='navigate-to-login'>
          <FormattedMessage
            id='promotion.log_in_to_apply_coupons'
            defaultMessage='Log-in to apply coupons'
          />
        </div>
      </div>
    );
  }

  // Has promo codes and user logged in → PromoCodeWidgetMobile
  return (
    <div
      className='user-promo-codes-container-mobile'
      id='promo-code-widget-mobile'
    >
      <PromoCodeWidgetMobile availablePromoCodes={availablePromoCodes} />
    </div>
  );
};

export default PromoCodesContainerMobile;
